module.exports = __webpack_public_path__ + "img/04-JS-find-out-whos-hiring.216cc060.svg";